<template>
  <v-card outlined class="pa-2 mx-4 mb-6 elevation-0">
    <v-row>
      <v-col cols="3">
        <v-col cols="12">
          <h2>Học viên và lớp</h2>
        </v-col>
      </v-col>
      <v-col cols="9" class="d-flex justify-end">
        <v-row class="ma-4 ml-0 justify-end">
          <v-col class="mr-4 pa-0"> </v-col>
          <v-col class="mr-4 pa-0"> </v-col>
          <v-col class="mr-4 pa-0"> </v-col>
          <v-col class="pa-0">
            <v-card
              class="border-radius-8 d-flex flex-column align-end elevation-0 pa-4"
              style="background-color: #fff9d0"
            >
              <div style="font-size: 24px"><strong>2218</strong></div>
              <div class="text-caption"><strong>Học viên</strong></div>
            </v-card>
          </v-col>
          <v-col class="pa-0 ml-4">
            <v-card
              class="border-radius-8 d-flex flex-column align-end elevation-0 pa-4"
              style="background-color: #caf4ff"
            >
              <div style="font-size: 24px"><strong>10</strong></div>
              <div class="text-caption"><strong>Lớp học</strong></div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {}
</script>

<style></style>
